import { Directive, HostListener, HostBinding } from '@angular/core';
import { UtilityServiceForMedicalService } from '../services/utility-service';
@Directive({
    selector: '[validation-tab-square-dir]'
})

export class ValidateEventEmitterDirective {
    constructor(private utilityServiceForMedicalService: UtilityServiceForMedicalService) {
    }

    @HostListener('click', ['$event']) onClick(event: MouseEvent) {
        if(event && event.target && event.target["parentElement"] && event.target["parentElement"].id){
            if(event.target["parentElement"].id.includes("switchBtnForTabSquare") ||
                event.target["parentElement"].id.includes("addBtnForTabSquare"))
            return;
        }
        this.emitTabSquareValidationEvent(event);      
    }

    @HostListener('keyup', ['$event']) onkeyup(event: KeyboardEvent) {
        if (event) {
            this.emitTabSquareValidationEvent(event); 
        }
      }

    emitTabSquareValidationEvent(event: any) {
        if(event && event.target){
            let isEmitRequired = false;
            let id: string = event.target["id"];
            if(!id.includes("tooltip") && !id.includes("addBtnForTabSquare") && !id.includes("switchBtnForTabSquare") && !id.includes("delete")){
                this.utilityServiceForMedicalService.emitTabSquareValidationEvent();
                event.preventDefault();
            }
        } 
       
    }

}
